(() => {
  const openRequestedSizeGuide = () => {
    const url = new URL(window.location.href);
    if (url.searchParams.get('scarfhold_open') !== 'size-guide') return;

    const opener = document.querySelector(
      'product-info[data-update-url="true"] .scarfhold-size-guide-opener button'
    );
    if (!opener) return;

    opener.click();
    url.searchParams.delete('scarfhold_open');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openRequestedSizeGuide, { once: true });
  } else {
    openRequestedSizeGuide();
  }
})();
